// extracted by mini-css-extract-plugin
module.exports = {"inspector":"inspector___3yeRo","form":"form___1Zsax","context-inspect":"context-inspect___1lJ2U"};